import type { OHLCV } from '../types/ohlcv';

/**
 * Merges two candle arrays keyed by `timestamp`, returning a single array in
 * ascending timestamp order. On duplicate timestamps, the entry from `b`
 * wins (used to let a fresh REST refetch supersede stale cached candles
 * while backfilled history from `a` is preserved).
 */
export function mergeCandles(a: OHLCV[], b: OHLCV[]): OHLCV[] {
  const byTimestamp = new Map<number, OHLCV>();
  for (const candle of a) {
    byTimestamp.set(candle.timestamp, candle);
  }
  for (const candle of b) {
    byTimestamp.set(candle.timestamp, candle);
  }
  return Array.from(byTimestamp.values()).sort((x, y) => x.timestamp - y.timestamp);
}

/** Index of the last candle opening at or before `time` in an ascending list; -1 when all open later. */
export function lastIndexAtOrBefore(list: readonly OHLCV[], time: number): number {
  let lo = 0;
  let hi = list.length - 1;
  let found = -1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    if (list[mid].timestamp <= time) {
      found = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }
  return found;
}
